import request from '@/utils/request'

export const sendCode = (data) => {
	return request({
		url: '/api/user/sendCode',
		method: 'get',
		params: data
	})
}

export const register = (data) => {
	return request({
		url: '/api/user/register',
		method: 'get',
		params: data
	})
}

// 获取微信登录二维码
export const getWechatQrCode = () => {
	return request({
		url: '/api/user/login/qrcode',
		method: 'get'
	})
}

// 检查微信登录状态
export const checkWechatLogin = (ticket) => {
	return request({
		url: '/api/user/login/wechat/check',
		method: 'get',
		params: {
			ticket
		}
	})
}

// 获取收藏列表
export const getFavorites = () => {
	return request({
		url: '/api/user/favs',
		method: 'get'
	})
}

// 提交意见反馈
export const submitFeedback = (data) => {
	return request({
		url: '/api/user/feedback',
		method: 'post',
		data
	})
}

// 账号登录
export const login = (data) => {
	return request({
		url: '/api/user/login/mobile',
		method: 'get',
		params: data
	})
}

// 获取个人信息
export const getUserProfile = () => {
	return request({
		url: '/api/user/profile',
		method: 'get'
	})
}

// 修改个人信息
export const updateUserProfile = (data) => {
	return request({
		url: '/api/user/profile',
		method: 'post',
		data
	})
}

// 收藏/取消收藏
export const toggleFavorite = (data) => {
	return request({
		url: '/api/user/fav',
		method: 'post',
		data
	})
}

// 修改密码
export const resetPwd = (data) => {
	return request({
		url: '/api/user/resetPwd',
		method: 'get',
		params: data
	})
}

// 申请提现
export const withdraw = (data) => {
	return request({
		url: '/api/user/withdraw',
		method: 'post',
		data
	})
}

// 绑定手机号
export const bindPhone = (data) => {
	return request({
		url: '/api/user/bindPhone',
		method: 'get',
		params: data
	})
}
	